<div class="claim-notification-section" [class.claim-notification-section--last-child]="lastChild">
    <ng-content></ng-content>
</div>
